module.exports = __webpack_public_path__ + "img/no_favorites.1eb57112.svg";